
import { Component, Vue } from "vue-property-decorator";

@Component
export default class GoodsDetail extends Vue
{
    /**
     * 商品数量
     * @private
     * @returns number
     */
    private goodsNum: number = 1;

    /**
     * 商品详情id
     * @private
     * @returns string
     */
     private get id(): string
    {
        return this.$route.query && (this.$route.query.id as string) || "";
    }

    /**
     * 跳转订单明细
     * @private
     * @returns void
     */
    private onActionOrderDetail(): void
    {
        this.$router.push({name: "order-detail-unsubscribe", params:{id: this.id}});
    }

    /**
     * 跳转首页
     * @private
     * @returns void
     */
    private onHome(): void
    {
        this.$router.push({name: "home"});
    }

}
